import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";
import * as React from "react";

export const CloseIcon = (props: SvgIconProps) => {
    const { viewBox = "-5 -5 20 20", ...rest } = props;

    return (
        <SvgIcon data-cy="closeIcon" viewBox={viewBox} {...rest}>
            <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
                <g fill="#210071" transform="translate(-15 -15)">
                    <g>
                        <path d="M15.238 15.238H24.762V24.762H15.238z"></path>
                    </g>
                </g>
            </g>
        </SvgIcon>
    );
};
